import { ArrowUpRight } from "lucide-react";

export const OtherWorkRow = ({ item, index }) => {
  return (
    <li
      data-testid={`other-work-${index}`}
      className="hairline-b border-b py-5 md:py-7 grid grid-cols-12 gap-4 md:gap-6 items-baseline group/row"
    >
      <div className="col-span-1 font-mono text-xs opacity-40">
        /{String(index + 1).padStart(2, "0")}
      </div>
      <div className="col-span-11 md:col-span-5 text-lg md:text-2xl font-bold tracking-tight">
        {item.title}
      </div>
      <div className="col-span-12 md:col-span-3 text-[10.5px] tracking-[0.22em] uppercase opacity-60">
        {item.brand}
      </div>
      <div className="col-span-12 md:col-span-3 text-sm text-[var(--muted)] leading-snug flex items-start justify-between gap-3">
        <span>{item.note}</span>
        <ArrowUpRight
          className="w-4 h-4 mt-0.5 opacity-0 group-hover/row:opacity-100 transition-opacity flex-shrink-0"
          strokeWidth={1.5}
        />
      </div>
    </li>
  );
};
